import {
  createMuiTheme,
  CssBaseline,
  Drawer,
  makeStyles,
  ThemeProvider,
} from "@material-ui/core";
import React from "react";
import Header from "../../../../components/Admin/Header";
import red from "@material-ui/core/colors/red";
import MyDrawer from "../../../../components/Admin/Drawer";
import Instagram from "./Instagram";
import { InstagramProvider } from "../../../../components/Instagram/InstagramContext";
import { useStyles, theme } from "../../theme.js";

const InstagramAdminPage = (props) => {
  const classes = useStyles();

  return (
    <InstagramProvider>
      <ThemeProvider theme={theme}>
        <Drawer
          className={classes.drawer}
          variant="permanent"
          classes={{
            paper: classes.drawerPaper,
          }}
          anchor="left"
        >
          <MyDrawer></MyDrawer>
        </Drawer>
        <div className={classes.adminMain}>
          <Header></Header>
          <Instagram></Instagram>
        </div>
        <CssBaseline></CssBaseline>
      </ThemeProvider>
    </InstagramProvider>
  );
};

export default InstagramAdminPage;
